var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 14C33.433 14 35 15.567 35 17.5V19.5C35 20.3284 34.3284 21 33.5 21H33V30C33 32.2091 31.2091 34 29 34H19C16.7909 34 15 32.2091 15 30V21H14.5C13.6716 21 13 20.3284 13 19.5V17.5C13 15.567 14.567 14 16.5 14H31.5ZM31 21H17V30C17 31.1046 17.8954 32 19 32H29C30.1046 32 31 31.1046 31 30V21ZM27 23.5C27.5523 23.5 28 23.9477 28 24.5C28 25.0523 27.5523 25.5 27 25.5H21C20.4477 25.5 20 25.0523 20 24.5C20 23.9477 20.4477 23.5 21 23.5H27ZM31.5 16H16.5C15.6716 16 15 16.6716 15 17.5V19H33V17.5C33 16.6716 32.3284 16 31.5 16Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.2e10dc06d8caa456207963afb559142f.svg";
export { ForwardRef as ReactComponent };